import { getPurchaseGlobalHref } from "app/common/hrefs";

import { setUrlQueryParam } from "./setUrlQueryParam";

export interface IGoToPurchasePageParams {
    workspace?: string;
    currency?: string;
    package?: string;
    period?: string;
    promo?: string | boolean;
    delayPayment?: string;
}

const returnUrlParam = "returnUrl";

export const getPurchasePageHref = (params: IGoToPurchasePageParams = {}): string => {
    const { workspace, currency, package: packageId, period, promo, delayPayment } = params;
    const url = new URL(getPurchaseGlobalHref());

    url.searchParams.set(returnUrlParam, location.href);
    setUrlQueryParam(url, "workspace", workspace);
    setUrlQueryParam(url, "currency", currency);
    setUrlQueryParam(url, "package", packageId);
    setUrlQueryParam(url, "period", period);
    setUrlQueryParam(url, "promo", promo);
    setUrlQueryParam(url, "delayPayment", delayPayment);

    return url.toString();
};

export function goToPurchasePage(params: IGoToPurchasePageParams = {}): void {
    window.open(getPurchasePageHref(params));
}
